import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pin-message-wrapper" }
const _hoisted_2 = { class: "pin-message" }
const _hoisted_3 = ["innerHTML"]

import { BaseIcon, KeepIcon } from "@/components/icons";
  import { computed, inject, ref } from "vue";
  import { IMessage } from "@/models";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PinnedMessage',
  props: {
    hidden: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const props = __props;

  const emitter = inject("emitter");
  const auctionStore = useAuctionStore();
  const newMessage = ref<IMessage | null>(null);
  const resetPinedMessageTimerId = ref<number | null>(null);

  const hasPinnedMessage = computed(() => {
    return auctionStore.pinMessage?.id || newMessage.value?.id;
  });

  const isShowPinnedIcon = computed(() => {
    return !newMessage.value?.text || auctionStore.pinMessage?.id === newMessage.value?.id;
  });

  emitter?.on("on:chat-new-message", (message: IMessage) => {
    newMessage.value = message;

    if (resetPinedMessageTimerId.value) {
      clearTimeout(resetPinedMessageTimerId.value);
    }

    resetPinedMessageTimerId.value = setTimeout(() => {
      newMessage.value = null;
    }, (auctionStore.newMessagePinSeconds || 60) * 1000);
  });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isShowPinnedIcon.value)
        ? (_openBlock(), _createBlock(_unref(BaseIcon), {
            key: 0,
            class: "keep",
            "icon-name": "keep",
            width: "20",
            height: "20",
            "view-box": "0 -960 960 960"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(KeepIcon))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "chat-message",
        innerHTML: newMessage.value?.text || _unref(auctionStore).pinMessage?.text
      }, null, 8, _hoisted_3)
    ])
  ], 512)), [
    [_vShow, !props.hidden && hasPinnedMessage.value]
  ])
}
}

})